import { m } from "@/paraglide/messages.js";
import { getMarkEglyGrowthBullets, getMarkEglyGrowthIntro } from "@/lib/mark-egly-profile";

export type DrivingRangeFeature = {
  title: string;
  body: string;
};

export function getDrivingRangeTagline(): string {
  return m.range_content_tagline();
}

export function getDrivingRangeIntro(): string {
  return m.range_content_intro();
}

export function getDrivingRangePracticeFeatures(): DrivingRangeFeature[] {
  return [
    {
      title: m.range_content_feature_0_title(),
      body: m.range_content_feature_0_body(),
    },
    {
      title: m.range_content_feature_1_title(),
      body: m.range_content_feature_1_body(),
    },
    {
      title: m.range_content_feature_2_title(),
      body: m.range_content_feature_2_body(),
    },
    {
      title: m.range_content_feature_3_title(),
      body: m.range_content_feature_3_body(),
    },
  ];
}

export function getDrivingRangeCommunityIntro(): string {
  return getMarkEglyGrowthIntro();
}

export function getDrivingRangeCommunityBullets(): string[] {
  return getMarkEglyGrowthBullets();
}
